import { ApiPlugin } from '@/plugins';

export default class Clinical {
  static async getResults({ page, sort } = {}) {
    const data = window?.API?.['clinical-results-page']?.nodes;
    if (!data) return [];

    const params = {};
    Object.keys(data.params).forEach((key) => {
      if (data.params[key]) {
        params[key] = data.params[key];
      }
    });
    try {
      const response = await ApiPlugin.get(data.api, {
        params: {
          ...params,
          page: page || 0,
          sort: sort || 'created',
        },
      });
      return response.data;
    } catch (e) {
      console.error('Error fetching getResults \n', e);
      return [];
    }
  }

  static getParams() {
    return window?.API?.['clinical-results-page']?.nodes?.params || {};
  }

  static getSearchBoxStructure() {
    const apiData = window.API?.['clinical-search-page']?.filters;
    if (apiData) {
      return apiData;
    }
    return {
      gender: {
        label: 'Pour',
        options: {
          _any: 'tous',
          male: 'homme',
          female: 'femme',
        },
      },
      overall_status: {
        label: 'Recrutement',
        options: {
          _any: 'tous',
          'Not yet recruiting': 'recrutement à venir',
          Recruiting: 'recrutement en cours',
        },
      },
      age: {
        prefix: 'Age',
        suffix: 'ans',
      },
      category: {
        label: 'Recherche par catégorie (saisir les premières lettres)',
        options: [],
      },
      localisation: {
        placeholder: 'Ville, code postal',
        options: [],
      },
      search: {
        label: 'Recherche libre',
      },
    };
  }

  static getSortStructure() {
    return window?.API?.['clinical-results-page']?.sort || null;
  }

  static getFirstSortKey() {
    return Object.keys(window?.API?.['clinical-results-page']?.sort?.options)?.[0] || '';
  }

  static async getCategoriesByName(name) {
    try {
      const response = await ApiPlugin.get(`/essais-cliniques/ajax/autocomplete/sujet?sujet=${name}`);
      return response.data;
    } catch (e) {
      console.error('Error fetching autocomplete \n', e);
      return [];
    }
  }

  static getId() {
    return window.API?.['clinical-informations-page']?.clinicaltrials_id || '';
  }

  static async getInformations(clinicalTrialId) {
    try {
      const response = await ApiPlugin.get(`/api/clinical_trials/information/${clinicalTrialId}`);
      // No Results
      if (response.data.status === 204) {
        console.warn(`Fetch /api/clinical_trials/information/${clinicalTrialId}  --> `, response.data);
        return null;
      }
      return response.data;
    } catch (e) {
      console.error('Error getInformations \n', e);
      return null;
    }
  }

  /**
   * Return the data from the search api for a specific clinicalTrialID.
   *
   * @param clinicalTrialId
   */
  static async getClinicalTrialData(clinicalTrialId) {
    try {
      const response = await ApiPlugin.get(`/api/clinical_trials/data/${clinicalTrialId}`);
      // No Results
      if (response.data.status === 204) {
        console.warn(`Fetch /api/clinical_trials/data/${clinicalTrialId}  --> `, response.data);
        return null;
      }
      return response.data;
    } catch (e) {
      console.error('Error getData \n', e);
      return null;
    }
  }
}
